import React from 'react';
import './App.css';
import CurrencyBoard from './CurrencyBoard';

const App: React.FC = () => {

  return (
    <CurrencyBoard></CurrencyBoard>
  );
}

export default App;
